import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { MerchantCountry } from "@/types/merchant";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import { getOffersRouteName } from "@/apps/merchant3/helpers/getOffersRouteName";
import { getCountryCode } from "@/apps/merchant3/helpers/flowType";
import { useKycReuse } from "@/apps/merchant3/hooks/useKycReuse";

type ComposableResult = {
  navigateToNextSteps: () => void;
};

/**
 * Composable for checkout navigation functionality
 */
export function useCheckoutNavigation(): ComposableResult {
  const { isKycReuseEnabled } = useKycReuse();
  const router = useRouter();
  const store = useStore();

  const navigateToNextSeps = (): void => {
    if (
      isKycReuseEnabled.value &&
      (store.state.merchant?.merchant?.country === MerchantCountry.MX ||
        store.state.merchant?.merchant?.country === MerchantCountry.PH) &&
      store.state.customer?.phone &&
      store.state.customer.phone.trim() !== ""
    ) {
      router.push({ name: getOffersRouteName(), params: { countryCode: getCountryCode() } });
      return;
    }

    router.push({
      name: RouteName.M3CustomerContactInfoView,
      params: { countryCode: getCountryCode() },
    });
  };

  return { navigateToNextSteps: navigateToNextSeps };
}
